import React, { Fragment } from 'react';
import Type from 'prop-types';
import { List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { ListItemMeta, Amount } from 'components';
import { ru } from 'locale';
import { formatDate, shortDateFullMonthFullYearFormat } from 'utils/date';
import useStyles from './CaseList.styles';

const CaseList = props => {
  const classes = useStyles();
  const { cases, onItemSelect } = props;

  const handleItemSelect = id => () => {
    onItemSelect(id);
  };

  const renderAmount = value => {
    return <Amount amount={{ value, currency: { code: 'RUR', minority: 0 } }} />;
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label={ru.listOfCases} className={classes.list}>
        {cases.map(caseItem => {
          const date = formatDate(caseItem.date, shortDateFullMonthFullYearFormat);

          return (
            <Fragment key={caseItem.caseNumber}>
              <Divider />
              <ListItem button onClick={handleItemSelect(caseItem.caseNumber)}>
                <ListItemText
                  primary={caseItem.caseNumber}
                  secondary={renderAmount(caseItem.amount)}
                />
                <ListItemMeta
                  primary={date}
                  classes={{
                    root: classes.meta,
                  }}
                />
              </ListItem>
            </Fragment>
          );
        })}
      </List>
    </div>
  );
};

CaseList.propTypes = {
  cases: Type.arrayOf(
    Type.shape({
      caseNumber: Type.string.isRequired,
      amount: Type.number.isRequired,
      date: Type.string.isRequired,
    }).isRequired,
  ).isRequired,
  onItemSelect: Type.func.isRequired,
};

export default CaseList;
